const cache = {};

//main api call to get list
const getList = (url,params) => { 
    return axios.get(url,{params});
};

//get field list
const getFieldsList = (modulekey,studio) => { 
    let params = {                        
        studio:studio
    };  
    let url ='/builder/fields/'+modulekey;   
    return getList(url,params);
};

//get by id
const getRecordById = (url) => { 
    let params = {};        
    return getList(url,params);
};
const getRecordByIdasync  = (url) => { 
    let params = {};        
    return getList(url,params);
};

//getLayout view
const getLayout = (modulekey,view,studio) => {
    let url = '/builder/fields/getlayout/'+modulekey+"/"+view;
    let params = {                        
        studio:studio
    };
    return getList(url,params);
};
const setLayout = (modulekey,view,studio,data) => {   
    let url = '/builder/fields/setlayout';
    let params = {                        
        module:modulekey,               
        studio:studio,
        data:data,
        view:view
    };
    return axios.post(url,params);
};


const setDeployLayout = (modulekey,view,studio,data) => {
    let url = '/builder/fields/setdeploylayout';
    let params = {                        
        module:modulekey,               
        studio:studio,
        data:data,
        view:view
    };
    return axios.post(url,params);
};


//check proxy
const isProxy = (obj) => {
    const handler = {
      get(target, prop, receiver) {
        target.__isProxy = true; // add flag to target object
        return Reflect.get(target, prop, receiver);
      },
    };
    const proxy = new Proxy(obj, handler);
    return obj.__isProxy === true;
  }

 
const isProxy1 = (obj) => {
    return Object.prototype.toString.call(obj) === '[object Proxy]';
};

const isObject = (obj) => {
    return typeof obj === 'object' && obj !== null && !!obj.__isProxy;
};



const deleteList = (listId) => {}

export { getList,getRecordById,getRecordByIdasync,isProxy,isProxy1,isObject, getFieldsList, getLayout ,setLayout,setDeployLayout }


//in next file
/* <script>
import { sendList, getLists, deleteList } from '../statics/functions.js'
...
created() { getLists() }, */